import { useState } from 'react';

import { useBreakpoints } from '~/hooks/use-breakpoints';

import styles from './styles';

const BannerAd = (): JSX.Element => {
  const [breakpoint, setBreakpoint] = useState<number>(0);
  const newBreakpoint = useBreakpoints().bk;

  // refreshes when breakpoint changes, and not on initial load
  if (breakpoint !== newBreakpoint && Math.abs(newBreakpoint - breakpoint) === 2) {
    setBreakpoint(newBreakpoint);
  }

  return (
    <div id="google-ad-manager___inline-1" className="rblad-aud_bottom" css={styles.container} />
  );
};

export default BannerAd;
